import { Grid, Button, MenuItem, FormControl, InputLabel, Select, TextField } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { InvitationFormProps } from '../../types';
import headerlogo from '../../../../../assets/icons/logo.svg';

import { InviteUsers } from '../types';
import { useAppPreloader } from 'hooks/useAppPreloader';
import EmailHeader from 'components/EmailHeader/EmailHeader';
export const Alluser: FC<InvitationFormProps> = ({ step, open, refetch, handleClose, emailtemps }) => {
  const classes = useStyles();
  const [registrationStep, setRegistrationStep] = useState(true);
  const {
    invitationStore: { sendAllusersInvitation, sendManualInvitationStepone },
    emailTemplatesTableStore: { getEmail, emailtemp },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  const sendAllusersInvitationReq = useMutation((data: any) => sendAllusersInvitation(data), {
    mutationKey: 'sendAllusersInvitationReq',
    onSuccess: (e) => {
      openNotification('success', `${e}`);
      refetch();
      reset();
      disablePreloader();
      handleClose();
    },
    onError: (e) => openNotification('error', `${e}`),
  });

  const sendManualInvitationSteponeReq = useMutation((data: any) => sendManualInvitationStepone(data, 'AllUsers'), {
    mutationKey: 'sendManualInvitationSteponeReq',

    onError: (e) => openNotification('error', `${e}`),
  });
  const { control, handleSubmit, reset } = useForm<InviteUsers>();

  const sample = ['Update Password'];
  const onSubmit2 = (data: any) => {
    const pass = {
      inviteType: data.inviteType === undefined ? 'register' : data.inviteType,
      templateSubjectPass: data.templateSubjectPass === undefined ? data.templateSubjectPass : data.templateSubjectPass,
      templateBodyPass: data.templateBodyPass === undefined ? data.templateBodyPass : data.templateBodyPass,
      templateButtonPass: data.templateButtonPass === undefined ? data.templateButtonPass : data.templateButtonPass,
      templateSignatureNamePass:
        data.templateSignatureNamePass === undefined ? data.templateSignatureNamePass : data.templateSignatureNamePass,
      templateSignaturePositionPass:
        data.templateSignaturePositionPass === undefined
          ? data.templateSignaturePositionPass
          : data.templateSignaturePositionPass,
    };
    // setRegistrationStep(!registrationStep);
    // emailtemps(registrationStep);

    sendAllusersInvitationReq.mutate(pass);
  };

  const replaceTemplateVariables = (text: string) => {
    return text
      .replace(/{{user_firstname}}/g, 'Username')
      .replace(/{{user_lastname}}/g, 'user_lastname')
      .replace(/{{user_email}}/g, 'user_email')
      .replace(/{{organization_name}}/g, 'organization_name')
      .replace(/{{Admin_fullname}}/g, 'AdminFullname')
      .replace(/{{admin_org}}/g, 'AdminOrg')
      .replace(/{{admin_email}}/g, 'AdminEmail');
  };

  const onSubmit = (data: InviteUsers) => {
    data.inviteType = data.inviteType === undefined ? sample[0] : data.inviteType;
    setRegistrationStep(!registrationStep);
    emailtemps(registrationStep);

    sendManualInvitationSteponeReq.mutate(data);
  };
  const getEmailTemplateReq = useQuery('getEmailTemplateReq', () => getEmail(), {
    onError: () => openNotification('error', `Can't get upgrade license info`),
  });
  step(registrationStep);
  useAppPreloader(sendManualInvitationSteponeReq.isLoading || sendAllusersInvitationReq.isLoading);
  return (
    <>
      {registrationStep === true && (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.formContainer}>
          <Controller
            name='inviteType'
            control={control}
            defaultValue={sample[0]}
            render={({ field, fieldState: { invalid } }) => (
              <Grid className={classes.row} container>
                <FormControl className={classes.input}>
                  <InputLabel>Invitation type :</InputLabel>
                  <Select {...field} defaultValue={sample[0]} error={invalid} className={classes.input}>
                    {sample.map((_item) => (
                      <MenuItem key={_item} value={_item}>
                        {_item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          />

          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    handleClose();
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button className={classes.btn2} type='submit' fullWidth variant='contained' color='secondary'>
                  Next
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
      {registrationStep === false && (
        <form
          onSubmit={handleSubmit(onSubmit2)}
          className={classes.formContainer}
          style={{ maxHeight: '70vh', overflowY: 'auto' }}
        >
          <Grid>
            <Grid container xs={12} className={classes.emailHeader}>
              <img src={headerlogo} alt='' />
            </Grid>
            <Grid className={classes.labels}>
              <p>Hello!</p>
            </Grid>
            {getEmailTemplateReq.isLoading && (
              <Grid className={classes.details}>
                <Controller
                  key='1'
                  name='templateSubjectReg'
                  control={control}
                  defaultValue='I am inviting you to create a new user password at:'
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        {...field}
                        error={invalid}
                        placeholder='I am inviting you to create a new user password at:'
                        defaultValue='I am inviting you to create a new user password at:'
                        helperText={invalid ? 'Required field' : ''}
                        className={classes.input}
                        multiline
                        rows={2}
                        InputProps={{ disableUnderline: true }}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )}
            <Grid className={classes.details}>
              {emailtemp.map((mail) => (
                <>
                  {mail.template === 'password' && (
                    <Controller
                      key='1'
                      defaultValue={mail.templateSubject ?? undefined}
                      name='templateSubjectPass'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='I am inviting you to create a new user password at:'
                            defaultValue={mail.templateSubject ?? undefined}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            multiline
                            rows={2}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}
                </>
              ))}

              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateBodyReg'
                    defaultValue='I am inviting you'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='I am inviting you'
                          defaultValue='I am inviting you'
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.input}
                          multiline
                          rows={2}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}

                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateBodyPass'
                        defaultValue={mail.templateBody ?? undefined}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container>
                            <div
                              contentEditable
                              dangerouslySetInnerHTML={{
                                __html: replaceTemplateVariables(field.value || mail.templateBody || ''),
                              }}
                              onBlur={(e) => field.onChange(e.currentTarget.innerHTML)}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid>
            <Grid className={classes.emailbtn}>
              <Grid item xs={6} container className={classes.btndetails}>
                <Button fullWidth variant='contained' color='primary'>
                  {getEmailTemplateReq.isLoading && (
                    <Controller
                      key='1'
                      name='templateButtonReg'
                      defaultValue='Create an account'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.btn1}>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='Create an account'
                            defaultValue='Create an account'
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}

                  {emailtemp.map((mail) => (
                    <>
                      {mail.template === 'password' && (
                        <Controller
                          key='1'
                          name='templateButtonPass'
                          defaultValue='Update Password'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.btn1}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Update Password'
                                defaultValue='Update Password'
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      )}
                    </>
                  ))}
                </Button>
              </Grid>
            </Grid>
            {/* <Grid className={classes.system}>
              <p className={classes.thanks}>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignatureNameReg'
                    defaultValue='Thanks, Yev Ledenov!'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.thanks}>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='Thanks, Yev Ledenov!'
                          defaultValue='Thanks, Yev Ledenov!'
                          helperText={invalid ? 'Required field' : ''}
                          className={`${classes.input} `}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}

                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignatureNamePass'
                        defaultValue={mail.templateSignatureName}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.thanks}>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder={`Thanks, ${user?.name} ${user?.lastName}`}
                              defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                              helperText={invalid ? 'Required field' : ''}
                              className={`${classes.input} `}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignaturePositionPass'
                    defaultValue=' System Administrator'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.admin}>
                        <TextField
                          {...field}
                          placeholder=' System Administrator'
                          defaultValue=' System Administrator'
                          helperText={invalid ? 'Required field' : ''}
                          className={` ${classes.input}`}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}
                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignaturePositionPass'
                        defaultValue={user?.permission}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.admin}>
                            <TextField
                              {...field}
                              placeholder={user?.permission}
                              defaultValue={user?.permission}
                              helperText={invalid ? 'Required field' : ''}
                              className={` ${classes.input}`}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid> */}
            {emailtemp.length > 0 && (
              <EmailHeader
                ImageUrl={emailtemp[1]?.templateProfileImageUrl ?? ''}
                EmailUrl={emailtemp[1]?.templateAdminEmail ?? ''}
                OrganizationName={emailtemp[1]?.templateOrganizationName ?? ''}
              />
            )}
          </Grid>
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn1}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    setRegistrationStep(!registrationStep);
                    emailtemps(registrationStep);
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button className={classes.btn2} type='submit' fullWidth variant='contained' color='secondary'>
                  Confirm & send invite
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};
